import { render } from "./ModulAufforderung.vue?vue&type=template&id=7d5f7b8c"
import script from "./ModulAufforderung.vue?vue&type=script&lang=js"
export * from "./ModulAufforderung.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__